import ArticlesPage from '@modules/professional/page/ArticlesPage';
import { loader } from '@modules/professional/page/loaders/articles-page-loader.server';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';
import type { MetaDescriptor } from 'react-router';
import { getPreloadImageLink } from '~/modules/images';
import type { APHandle } from '~/modules/root';
import type { SearchResultItem, SearchResults } from '~/modules/search';
import { mergeMeta } from '~/modules/seo';
import { getImagesSizes } from '~/utils/image-sizes-utils';

export { loader };

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data } = props;
        const isDesktop = data?.deviceType === 'desktop';
        const preloadImages = data?.searchResult?.hits
            ? prefetchProfessionalJournalImages(
                  data.searchResult.hits,
                  isDesktop,
              )
            : [];
        return [...preloadImages];
    },
);

export const prefetchProfessionalJournalImages = (
    hits: SearchResults<SearchResultItem>['hits'],
    isDesktop: boolean,
) => {
    const numberTilesToPreload = isDesktop ? 4 : 2;

    return hits.slice(0, numberTilesToPreload).reduce((acc, hit, index) => {
        if (!hit.LibraryThumbs?.Thumb_lg) return acc;
        const imageUrl: string = hit.LibraryThumbs.Thumb_lg;
        const imageSizes = getImagesSizes({
            desktop: index % 2 === 0 ? 434 : 340,
            mobile: 204,
        });
        const link = !isDesktop
            ? getPreloadImageLink(undefined, imageUrl, imageSizes)
            : getPreloadImageLink(imageUrl, undefined, imageSizes);
        return acc.concat(link);
    }, [] as MetaDescriptor[]);
};

export const handle: APHandle = {
    category: 'blogpost',
    allowFilters: false,
    hideContactArchiPro: true,
};

export const shouldRevalidate = shouldRevalidateLeaf;
export default ArticlesPage;
